import { Badge } from 'journey-ui'
import React from 'react'
import { getRuleDescriptions } from '../../helpers'

export const ToppingRules = ({ rules, tiles }) => (
  <div className="flex flex-wrap justify-center space-x-1">
    {getRuleDescriptions(rules, tiles).map((ruleDescription) => (
      <Badge key={ruleDescription} className="bg-gray-50 m-1">{ruleDescription}</Badge>
    ))}
  </div>
)
